import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueRouter from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
Vue.use(VueRouter);
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-app']
Vue.prototype.pullApp = function (){
  var device = navigator.userAgent;
  if (device.indexOf('Android') > -1) {
    var pattXiaoMi = new RegExp(/\(.*Android.*(MI|Mi|Redmi).*\)/);
    var pattHuaWei = new RegExp(/\(.*Android.*(HUAWEI|HONOR).*\)/i);
    var pattOppo = new RegExp(/\(.*Android.*OPPO.*\)/);
    var pattVivo = new RegExp(/\(.*Android.*(vivo|VIVO).*\)/);
    if (pattXiaoMi.test(device)) {
      window.location.href = `mimarket://details?id=com.justjump.loop`
    } else if (pattHuaWei.test(device)) {
      window.location.href = `appmarket://details?id=com.justjump.loop`
    } else if (pattOppo.test(device)) {
      window.location.href = `oppomarket://details?packagename=com.justjump.loop`
    } else if (pattVivo.test(device)) {
      window.location.href = `vivomarket://details?id=com.justjump.loop`
    }
    setTimeout(() => {
      window.location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.justjump.loop'; 
    }, 2000);
  } else if (device.indexOf('iPhone') > -1) {
    window.location.href = 'https://apps.apple.com/cn/app/id1140848844'; 
  }
}

Vue.prototype.pullAppEn = function() {
  var device = navigator.userAgent;
  if (device.indexOf('Android') > -1) {
    window.location.href = 'https://play.google.com/store/apps/details?id=com.justjump.loopintl';
  } else if (device.indexOf('iPhone') > -1) {
    window.location.href = 'https://apps.apple.com/cn/app/id1617032569';
  }
}

Vue.prototype.registerWechatSdk = async function (url) {
  console.log(url)
  // const baseUrl = 'http://192.168.1.23:8080/'
  const baseUrl = 'https://api.loopsports.cn/'
  const nonceStr = 'loop'
  const timestamp = + new Date()
  let res = await this.axios.post(`${baseUrl}user/wx_getJsSdkSign`, {
    type: 1,
    nonceStr,
    timestamp,
    url,
  });
  wx.config({
    debug: true, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印
    appId: 'wx88a8fee775ad8b80', // 必填，公众号的唯一标识
    timestamp, // 必填，生成签名的时间戳
    nonceStr, // 必填，生成签名的随机串
    signature: res.data.signature,// 必填，签名
    jsApiList: [], // 必填，需要使用的 JS 接口列表
    openTagList: ['wx-open-launch-app'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
  });
  wx.ready((res) => {
    console.log(res)
  })
  wx.error((err) => {
    console.log(err)
  })
}

import Competition from '../src/view/competition.vue';
import Group from '../src/view/group.vue';
import Download from '../src/view/download.vue';
import Privacy from '../src/view/privacy.vue';
import PrivacyEn from '../src/view/privacy_en.vue';
import DownloadEn from '../src/view/download_en.vue';
import TermOfUseEn from '../src/view/termOfUse_en.vue';
import CompetitionEn from '../src/view/competition_en.vue';
import GroupEn from '../src/view/group_en.vue';
import Service from '../src/view/service.vue';
import AccountEn from '../src/view/account_en.vue';
import PrivacyJudge from './view/privacyJudge.vue';
import ServiceJudge from './view/serviceJudge.vue';
import Metronome from './view/metronome.vue';
import Wxpay from './view/wxpay.vue';
const CastReceiver = () => import('./view/cast.vue');
const router = new VueRouter({
  mode: "history", // 去掉#
  routes: [
    { path: "/competition", component: Competition, name: "competition" },
    { path: "/group", component: Group, name: "group" },
    { path: "/download", component: Download, name: "download" },
    { path: "/privacy", component: Privacy, name: "privacy" },
    { path: "/privacyJudge", component: PrivacyJudge, name: "privacyJudge" },
    { path: "/serviceJudge", component: ServiceJudge, name: "serviceJudge" },
    { path: "/download_en", component: DownloadEn, name: "download_en" },
    { path: "/privacy_en", component: PrivacyEn, name: "privacy_en" },
    { path: "/termOfUse_en", component: TermOfUseEn, name: "termOfUse_en" },
    {
      path: "/competition_en",
      component: CompetitionEn,
      name: "competition_en",
    },
    { path: "/group_en", component: GroupEn, name: "group_en" },
    { path: "/service", component: Service, name: "service" },
    { path: "/account_en", component: AccountEn, name: "account_en" },
    { path: "/metronome", component: Metronome, name: "metronome" },
    { path: "/wxpay", component: Wxpay, name: "wxpay" },
    { path: "/cast", component: CastReceiver, name: "cast" },
  ],
});

const app = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
}).$mount('#app')
